import React, {useRef, useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import InputDateTime from "../../../components/input-datetime";
import SelectComponent from "../../../components/select-component";
import Button from "../../../components/button";
import {FaList, FaPrint} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import Card from "../../../components/card";
import moment from "moment/moment";
import reportService from "../../../services/report-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import general from "../../../utils/general";

const initialFilters = {
    init: moment().startOf('month').toDate(),
    end: moment().endOf('month').toDate(),
    project: null
}

const ServicesProvided = () => {
    const [data, setData] = useState([]);
    const [printData, setPrintData] = useState(null);
    const [filters, setFilters] = useState(initialFilters);

    const [columnDefs] = useState([
        {field: "softwareAttendances", headerName: "Atendimentos", flex: 1, minWidth: 250},
        {field: "hardwareAttendances", headerName: "Chamados", flex: 1, minWidth: 250},
        {field: "trainings", headerName: "Treinamentos", flex: 1, minWidth: 250},
        {field: "versions", headerName: "Versões", flex: 1, minWidth: 250},
        {field: "afterSales", headerName: "Pós-vendas", flex: 1, minWidth: 250},
    ]);

    const gridRef = useRef();
    const handleInput = (value, name) => setFilters(prev => ({...prev, [name]: value}));
    const handleSelect = (id, value) => setFilters(prev => ({...prev, [id]: value}));

    const {data: projects} = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projects"]
    });
    const formatDate = date => date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : "";

    const apply = () => {
        const init = formatDate(filters.init);
        const end = formatDate(filters.end);
        const formData = new FormData()

        formData.append("init", init);
        formData.append("end", end);
        formData.append("project", filters.project?.value ?? "");
        formData.append("project_name", filters.project?.label ?? "");

        reportService.servicesProvided(formData)
            .then(({data}) => {
                setData([{
                    hardwareAttendances: data.hardwareAttendances.length,
                    softwareAttendances: data.softwareAttendances.length,
                    trainings: data.trainings.length,
                    versions: data.versions.length,
                    afterSales: data.afterSales.length
                }])
                data.period = general.formatDate(filters.init, "DD/MM/YYYY") + " até " + general.formatDate(filters.end, "DD/MM/YYYY")
                setPrintData(data)
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível prosseguir.");
            });
    }

    const handlePrint = () => {
        if (!gridRef.current || !printData) {
            toast.error("Aplique os filtros antes de imprimir.");
            return;
        }

        localStorage.setItem('services-provided', JSON.stringify(printData));
        window.open('/reports/print-services-provided', '_blank');
    }

    return (
        <TemplateDefault title="Relatório de serviços prestados" style={{height: "calc(100vh - 159px)"}}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-init"} name={"init"} label={"Inicio"} selected={filters.init}
                                       onChange={(value) => handleInput(value, "init")}/>
                    </div>
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-end"} name={"end"} label={"Fim"} selected={filters.end}
                                       onChange={(value) => handleInput(value, "end")}/>
                    </div>
                    <div className="col-span-6 text-gray-900">
                        <SelectComponent
                            instanceId="projects"
                            label="Projeto"
                            options={projects ?? []}
                            value={filters.project}
                            onChange={(value) => handleSelect("project", value)}
                            name="projects"
                        />
                    </div>
                    <Button col={"col-span-1"} onClick={apply}>
                        <FaList/> <span className={"ml-1"}>Aplicar</span>
                    </Button>
                    <Button col={"col-span-1"} onClick={handlePrint}>
                        <FaPrint/>
                    </Button>

                </div>
                <div className={"ag-theme-quartz grid mt-4"}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={data}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        domLayout='autoHeight'
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default ServicesProvided;
